export default (events = ['DOMContentLoaded', 'vue:loaded']) => {
  const loaded =
    document.readyState == 'complete' || document.readyState == 'loaded';

  const loadInEvent = () => {
    const loadInEl = (el) => (el.dataset.loaded = 1);
    const intersectionEvent = (entries, observer) => {
      entries.map((entry) => (entry.isIntersecting || entry.intersectionRatio > 0) && loadInEl(entry.target));
    };
    const observer = new IntersectionObserver(intersectionEvent, {
      threshold: 1,
      rootMargin: `${window.innerHeight / 4}px`
    });
    [...document.querySelectorAll('[data-loaded]')].map(el => observer.observe(el));
  };

  if (loaded) return loadInEvent();
  
  events.map(event => document.addEventListener(event, loadInEvent));
};
